<canvas #canvas *ngIf="!resolve" [width]="this.property.blur.width" [height]="this.property.blur.height" class="blur-canvas"></canvas>
<img #img [hidden]="!resolve" class="blur-img">